// src/data/missions.ts — Misiones Fase 5 (Villa + Ruta)
import type { MissionState, MissionObjective } from '../entities/player.js';

export type MissionDef = {
  id: string;
  name: string;
  description: string;
  giverNpcId: string; // quién la da
  zone: string;
  type: 'principal'|'secundaria'|'exploracion'|'combate'|'captura'|'entrega'|'descubrimiento';
  requiredTrainerLevel?: number;
  requiredFlags?: string[];
  objectives: Omit<MissionObjective,'current'>[];
  rewards: { aureos?: number; trainerXp?: number; items?: {id:string; qty:number}[]; xpAsteria?: number; unlockFlag?: string };
  repeatable?: boolean;
};

export const MISSIONS: MissionDef[] = [
  {
    id:'primer_descubrimiento',
    name:'Primer Descubrimiento',
    description:'Explora la Ruta Aurelia y descubre su corazón. Llega al Árbol Madre.',
    giverNpcId:'alba',
    zone:'villa_aurelia',
    type:'exploracion',
    objectives:[
      { id:'visitar_ruta', type:'visitar_zona', target:'ruta_aurelia', required:1, description:'Entra en Ruta Aurelia' },
      { id:'visitar_arbol', type:'visitar_zona', target:'ruta_arbol_madre', required:1, description:'Encuentra el Árbol Madre (10,19 en Ruta)' },
    ],
    rewards:{ aureos:40, trainerXp:15, items:[{id:'baya_lumen', qty:2}] }
  },
  {
    id:'primer_vinculo',
    name:'Primer Vínculo',
    description:'El primer lazo con Aetheria nace al capturar. Atrapa tu primera Asteria.',
    giverNpcId:'liora',
    zone:'tienda_aurelia',
    type:'captura',
    objectives:[
      { id:'capturar_1', type:'capturar_cantidad', target:'any', required:1, description:'Captura 1 Asteria salvaje' },
    ],
    rewards:{ aureos:60, trainerXp:25, items:[{id:'nucleo_vinculo', qty:5}, {id:'pocion_aurea', qty:2}] }
  },
  {
    id:'ayuda_investigador',
    name:'Ayuda al Investigador',
    description:'El Prof. Ori necesita un Fragmento de Geoda y una carta de Alba. Investiga la ruina y el puente.',
    giverNpcId:'profesor_ori',
    zone:'casa_npc',
    type:'entrega',
    objectives:[
      { id:'hablar_alba', type:'hablar_npc', target:'alba', required:1, description:'Habla con Alba en la plaza y recibe la Carta' },
      { id:'conseguir_fragmento', type:'conseguir_item', target:'fragmento_geoda', required:1, description:'Recoge el Fragmento de Geoda cerca de la Ruina (14,17)' },
      { id:'entregar_ori', type:'hablar_npc', target:'profesor_ori', required:1, description:'Entrega todo a Ori' },
    ],
    rewards:{ aureos:80, trainerXp:30, items:[{id:'cristal_lumen', qty:3}, {id:'mapa_ruta', qty:1}], unlockFlag:'mision_ori_completa' }
  },
  {
    id:'entrenamiento_mira',
    name:'Entrenamiento con Mira',
    description:'Mira del puente busca un rival digno. ¡Véncela!',
    giverNpcId:'aventurera_mira',
    zone:'ruta_aurelia',
    type:'combate',
    objectives:[
      { id:'derrotar_mira', type:'derrotar_entrenador', target:'mira_aventurera', required:1, description:'Derrota a Mira en Ruta Aurelia' },
    ],
    rewards:{ aureos:40, trainerXp:20, items:[{id:'estimulante', qty:2}] }
  },
  {
    id:'coleccionista_aqua',
    name:'Coleccionista de Agua',
    description:'Joren quiere ver una Neritha. Captura o muestra una.',
    giverNpcId:'pescador',
    zone:'ruta_aurelia',
    type:'descubrimiento',
    objectives:[
      { id:'descubrir_neritha', type:'descubrir_asteria', target:'neritha', required:1, description:'Descubre a Neritha (puente de noche o hierba húmeda)' },
    ],
    rewards:{ aureos:50, trainerXp:18, items:[{id:'pan_aureliano', qty:3}] }
  },
];

export function getMissionDef(id:string): MissionDef | undefined { return MISSIONS.find(m=>m.id===id); }

export function createInitialMissions(): import('../entities/player.js').MissionState[] {
  return MISSIONS.map(def=> ({
    id: def.id,
    status: def.id==='primer_descubrimiento' || def.id==='primer_vinculo' ? 'disponible' : 'bloqueada',
    progress: 0,
    objectives: def.objectives.map(o=> ({ ...o, current:0 })),
  }));
}
